/**
 * MultipleChoice.jsx
 *
 * Renders 4 college options for Easy Mode.
 * Handles selection, visual feedback (correct/incorrect), and lock state.
 *
 * Double-submission prevention:
 * - `locked` prop gates all click handlers
 * - Once an answer is selected, component enters feedback state
 * - Parent controls lock state via timer expiry or selection
 */

import React from 'react';

const MultipleChoice = ({ choices, onSelect, selectedAnswer, correctAnswer, locked }) => {
  const handleClick = (choice) => {
    if (locked) return;
    onSelect(choice);
  };

  return (
    <div className="multiple-choice-grid" key={choices.join(',')}>
      {choices.map((choice, idx) => {
        let className = 'choice-button';

        if (locked && selectedAnswer !== null) {
          if (choice === correctAnswer) {
            className += ' correct';
          } else if (choice === selectedAnswer && selectedAnswer !== correctAnswer) {
            className += ' incorrect';
          } else {
            className += ' dimmed';
          }
        } else if (locked && selectedAnswer === null) {
          // Timed out — no selection
          if (choice === correctAnswer) {
            className += ' correct';
          } else {
            className += ' dimmed';
          }
        } else if (!locked && choice === selectedAnswer) {
          className += ' selected';
        }

        return (
        <button
  key={idx}
  className={className}
  onClick={() => handleClick(choice)}
  onMouseDown={e => e.preventDefault()}
  onTouchStart={e => { e.preventDefault(); e.currentTarget.blur(); }}
  onFocus={e => e.target.blur()}
  tabIndex={-1}
  disabled={locked}
>
            <span className="choice-letter">{String.fromCharCode(65 + idx)}</span>
            <span className="choice-text">{choice}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MultipleChoice;
